import { EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../settings/app-settings.service';
var EditProfileComponent = /** @class */ (function () {
    function EditProfileComponent(settings) {
        this.settings = settings;
        this._disabled = false;
        this._loading = false;
        this.passwordControl = new FormControl('', [
            Validators.minLength(this.settings.MIN_PASSWORD_LENGTH),
            Validators.required
        ]);
        this.firstNameControl = new FormControl(undefined, [Validators.required]);
        this.lastNameControl = new FormControl(undefined, [Validators.required]);
        this.profileImageControl = new FormControl(undefined);
        this.save = new EventEmitter();
        this.createForm();
    }
    Object.defineProperty(EditProfileComponent.prototype, "changePassword", {
        get: function () {
            return this._changePassword;
        },
        set: function (value) {
            this._changePassword = value;
            if (value) {
                this.userForm.addControl('password', this.passwordControl);
            }
            else {
                this.userForm.removeControl('password');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditProfileComponent.prototype, "profile", {
        set: function (value) {
            this.userForm.patchValue(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditProfileComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (this._disabled) {
                this.userForm.disable();
            }
            else {
                this.userForm.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditProfileComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (val) {
            this._loading = val;
            if (this._loading && !this.userForm.disabled) {
                this.userForm.disable();
            }
            else if (!this._loading && !this._disabled && this.userForm.disabled) {
                this.userForm.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    EditProfileComponent.prototype.createForm = function () {
        this.userForm = new FormGroup({
            firstName: this.firstNameControl,
            lastName: this.lastNameControl,
            profileImage: this.profileImageControl
        });
    };
    EditProfileComponent.prototype.submit = function () {
        if (this.userForm.valid) {
            this.save.next(this.userForm.value);
        }
        else {
            // Highlight any errors
            this.userForm.markAsTouched();
            for (var control in this.userForm.controls) {
                this.userForm.get(control).markAsTouched();
            }
        }
    };
    return EditProfileComponent;
}());
export { EditProfileComponent };
